module.exports = __webpack_public_path__ + "static/media/15.69266bf7.jpg";